import(/* webpackMode: "eager", webpackExports: ["LoginForm"] */ "/app/code/build/apps/web/src/app/[locale]/(auth)/login/login-form.tsx");
;
import(/* webpackMode: "eager" */ "/app/code/build/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/code/build/node_modules/next/dist/client/link.js");
